import { html, TemplateResult } from 'lit';
import { live } from 'lit/directives/live.js';
import { staticText } from '../../../static-text';
import { Dispatcher } from '../../../types/booking-request';

export function feedbackTextarea(
	feedback: string,
	dispatch: Dispatcher
): TemplateResult {
	const changeHandler = ( e: InputEvent ) => {
		if ( e.target !== e.currentTarget ) {
			return;
		}

		if ( !( e.target instanceof HTMLTextAreaElement ) ) {
			throw new Error( 'e.target should be instanceof HTMLTextAreaElement' );
		}

		dispatch( {
			type: 'UPDATE_FEEDBACK',
			feedback: e.target.value,
		} );
	};

	return html`
		<div class="form__row">
			<div class="form__label-container type-d">
				<label class="form__label" for="feedback">
					${staticText.feedbackOrQuestion}
				</label>
			</div>

			<textarea
				.value=${live( feedback )}
				@change=${changeHandler}
				class="form__textarea"
				id="feedback"
				name="feedback"
			></textarea>
		</div>
	`;
}
